import SpeechBubble from './bubble'
import LibraryMouse from './LibrarayMouse'

export default class CustomSpeechBubble {
  constructor (manager, container, x, y, editor, id, editmode) {
    this.manager = manager
    this.container = container
    this.editor = editor
    this.editmode = editmode;
    this.init()

    this.id = id
    this.x = x
    this.y = y
    this.active = false

    if (editmode != true){
      this.addButtons()

      this.mode = CustomSpeechBubble.modes.EDIT_TAIL
    }

  }
}

CustomSpeechBubble.prototype.init = function () {
  this.canvas = document.createElement('canvas')
  this.values = null
  this.canvas.id = 'CursorLayer'
  this.canvas.width = 500
  this.canvas.height = 450
  if (this.editmode != true){
    this.canvas.style.position = 'absolute'
  }else{
    this.canvas.style.position = 'relative'
  }

  this.canvas.style.pointerEvents = 'none'
  this.container.appendChild(this.canvas)
  // this.mouse = new LibraryMouse(this.canvas);
  this.speechBubble = new SpeechBubble(this.canvas.getContext('2d'))
  this.speechBubble.setTargetPos(this.speechBubble.panelBounds.right + 40, this.speechBubble.panelBounds.bottom + 59)
  this.speechBubble.text = '\'Hello world text\''

  this.speechBubble.draw()
}
CustomSpeechBubble.prototype.clear = function () {
  this.canvas.getContext('2d').clearRect(0, 0, this.canvas.width, this.canvas.height)
}

CustomSpeechBubble.prototype.setText = function (txt) {
  this.speechBubble.text = txt
  if (this.editmode) {
    this.speechBubble.setTargetPos(this.speechBubble.panelBounds.right + 40, this.speechBubble.panelBounds.bottom + 59)
  }
  this.speechBubble.draw()
}

CustomSpeechBubble.prototype.updateInitialTail = function () {
  let tx= this.speechBubble.panelBounds.right -15
   let ty = this.speechBubble.panelBounds.bottom + 55
  this.canvas.getContext('2d').clearRect(0, 0, this.canvas.width, this.canvas.height)
   this.speechBubble.setTargetPos(tx, ty )
  this.tailButton.style.left = (tx + $(this.tailButton).width() + 15) + 'px'
  this.tailButton.style.top = (ty + $(this.tailButton).height() + 15) + 'px'
   this.speechBubble.draw()
}

CustomSpeechBubble.prototype.setValues = function (obj) {
  this.clear()
  this.values = obj
  this.speechBubble.text = obj.text
  this.speechBubble.panelBorderColor = obj.borderColor
  this.speechBubble.panelFillColor = obj.fillColor
  this.speechBubble.fontColor = obj.fontColor
  let bounds = null;

  switch (obj.size) {
    case 'SIZE_BIG':
      bounds = new SpeechBubble.Bounds(100, 170, 180, 50);
      this.speechBubble.tailBaseWidth = 15;
      this.speechBubble.cornerRadius = 35;
      break
    case 'SIZE_MED':
      bounds = new SpeechBubble.Bounds(100, 190, 150, 50);
      this.speechBubble.tailBaseWidth = 10;
      this.speechBubble.cornerRadius = 25;
      break
    case 'SIZE_SMALL':
      bounds = new SpeechBubble.Bounds(100, 200, 100, 50);
      this.speechBubble.tailBaseWidth = 10;
      this.speechBubble.cornerRadius = 15;
      break
    default:
  }
  this.speechBubble.fontColor = obj.fontColor
  this.speechBubble.panelBounds = bounds

  this.speechBubble.draw()
  if(this.editmode){
    let tb = this.speechBubble.panelBounds;
    this.speechBubble.setTargetPos(this.speechBubble.panelBounds.right + 40, this.speechBubble.panelBounds.bottom + 59)
  }else{
    this.updateButtonPos();
  }

}

CustomSpeechBubble.prototype.updateTail = function () {

}
CustomSpeechBubble.prototype.updateTailTouch = function (evt) {
  const of = $(this.canvas).offset()
  let nx, touch, ny
  if (evt.type == 'touchmove') {
    touch = evt.changedTouches[0]
    nx = (touch.clientX - of.left)
    ny = (touch.clientY - of.top)
  } else {
    nx = (evt.clientX - of.left + this.shiftX)
    ny = (evt.clientY  - of.top + this.shiftY)
  }
  if (nx > this.canvas.width * this.editor.pageScale) {
    nx = this.canvas.width * this.editor.pageScale
  }
  if (ny > this.canvas.height * this.editor.pageScale) {
    ny = this.canvas.height * this.editor.pageScale
  }
  if (nx < 0) {
    nx = 0
  }
  if (ny < 0) {
    ny = 0
  }
  nx = nx / this.editor.pageScale
  ny = ny / this.editor.pageScale

  this.canvas.getContext('2d').clearRect(0, 0, this.canvas.width, this.canvas.height)
  this.speechBubble.setTargetPos(nx, ny)
  this.speechBubble.draw()

  this.tailButton.style.left = (nx + $(this.tailButton).width() + 15) + 'px'
  this.tailButton.style.top = (ny + $(this.tailButton).height()+15) + 'px'
}

CustomSpeechBubble.prototype.addButtons = function () {
  this.buttons = {}
  this.buttons.tail = this.addTailButton()
  this.buttons.highlighElement = this.addHighlightElement()
  this.buttons.edit = this.addEditButton()
  //this.buttons.drag = this.addDragButton()

  // this.buttons.finish = this.addFinishButton()
}

CustomSpeechBubble.prototype.addHighlightElement = function () {
  this.highlighElement = document.createElement('div')
  this.highlighElement.className = 'speech-bubble-highlight'
  this.highlighElement.style.opacity = 0;
  this.highlighElement.innerHTML = ''




  this.container.appendChild(this.highlighElement, this.canvas)
  return this.highlighElement
}
/*

CustomSpeechBubble.prototype.addEditButton = function () {
  this.editButton = document.createElement('div')
  this.editButton.className = 'speech-bubble-edit-button'


  this.editButton.onpointerdown = this.editButtonAction.bind(this)



  this.container.appendChild(this.editButton, this.canvas)
  return this.editButton
}
*/
CustomSpeechBubble.prototype.addEditButton = function () {
  this.editButton = document.createElement('div')
  this.editButton.className = 'speech-bubble-edit-button'

  this.editButton.innerHTML = '<img src="../images/Bubble_Edit.svg" width="30px">'

  this.editButton.onpointerdown = this.editButtonAction.bind(this)

  this.container.appendChild(this.editButton, this.canvas)
  return this.editButton
}
CustomSpeechBubble.prototype.updateButtonPos = function () {
  if(!this.editmode){
    /*
    this.dragButton.style.left = (this.x + this.speechBubble.panelBounds.left - 50) + 'px'
    this.dragButton.style.top = (this.y + this.speechBubble.panelBounds.top) + 'px'
*/
    this.editButton.style.left = (this.x + this.speechBubble.panelBounds.right) + 'px'
    this.editButton.style.top = (this.y + this.speechBubble.panelBounds.top) + 'px'

    this.highlighElement.style.left = (this.x + this.speechBubble.panelBounds.left-10) + 'px'
    this.highlighElement.style.top = (this.y + this.speechBubble.panelBounds.top-10) + 'px'
    this.highlighElement.style.width = (this.speechBubble.panelBounds.right  - this.speechBubble.panelBounds.left+20)+ 'px'
    this.highlighElement.style.height = (this.speechBubble.panelBounds.bottom - this.speechBubble.panelBounds.top+20) + 'px'
  }


}
CustomSpeechBubble.prototype.addDragButton = function () {
  /*
  this.dragButton = document.createElement('div')
  this.dragButton.className = 'speech-bubble-edit-button'
  this.dragButton.innerHTML = 'DRAG'
  this.container.appendChild(this.dragButton, this.canvas)
  return this.dragButton

   */
}

CustomSpeechBubble.prototype.addFinishButton = function () {
  this.finishButton = document.createElement('div')
  this.finishButton.className = 'speech-bubble-finish-button'

  this.finishButton.innerHTML = 'OK'

  this.finishButton.onpointerdown = this.finishButtonAction.bind(this)

  this.finishButton.style.left = (this.x + this.speechBubble.panelBounds.right - 50) + 'px'
  this.finishButton.style.top = (this.y + this.speechBubble.panelBounds.top) + 'px'

  this.container.appendChild(this.finishButton, this.canvas)
  return this.finishButton
}

CustomSpeechBubble.prototype.addTailButton = function () {
  this.tailButton = document.createElement('div')
  this.tailButton.className = 'speech-bubble-tail-button'

  this.tailButton.innerHTML = '<img src="../images/Bubble_Move.svg" width="20px">'

  /*
  this.tailButton.onpointerdown = this.startTailDrag.bind(this);
  this.tailButton.onpointerup = this.stopTailDrag.bind(this);
*/
  this.tailButton.style.left = (this.x + this.speechBubble.target.x) + 'px'
  this.tailButton.style.top = (this.y + this.speechBubble.target.y) + 'px'

  this.container.appendChild(this.tailButton, this.canvas)
  return this.tailButton
}

CustomSpeechBubble.prototype.hideButton = function (button) {
  this.buttons[button].style.display = 'none'
}

CustomSpeechBubble.prototype.showButton = function (button) {
  this.buttons[button].style.display = 'block'
}

CustomSpeechBubble.prototype.editButtonAction = function () {
  this.editor.editTextBubble(this.id)
}

CustomSpeechBubble.prototype.finishButtonAction = function () {
  this.mode = CustomSpeechBubble.modes.NORMAL
  // this.manager.deactivateAllBubbles();
}

CustomSpeechBubble.prototype.initEditTailMode = function () {
  this.tailButton.addEventListener('mousedown', this.startTailDrag.bind(this))

  // this.mouse.addEventListener("touchstart", this.startTailDrag.bind(this));
  this.tailButton.addEventListener('touchstart', this.startTailDrag.bind(this))

}

CustomSpeechBubble.prototype.initEditTextMode = function () {
  this.removeMouseEvents()
}

CustomSpeechBubble.prototype.initEditMode = function () {

  //this.showButton('tail')
  /*
  this.tailButton.addEventListener('mousedown', this.startTailDrag.bind(this))
  this.tailButton.addEventListener('mouseup', this.stopTailDrag.bind(this))
  this.tailButton.addEventListener('touchstart', this.startTailDrag.bind(this))
  this.tailButton.addEventListener('touchend', this.stopTailDrag.bind(this))
  */

  this.editor.toggleDraggable(false)
}

CustomSpeechBubble.prototype.initNormalMode = function () {
  this.removeMouseEvents()
  this.showButton('edit')
  this.hideButton('finish')
  this.hideButton('tail')
}

CustomSpeechBubble.prototype.activateElement = function () {
    this.highlighElement.style.opacity = 1
  this.showButton('tail')
  this.showButton('edit')


}
CustomSpeechBubble.prototype.deActivateElement = function () {
  this.highlighElement.style.opacity = 0
  this.hideButton('tail')
  this.hideButton('edit')
}

CustomSpeechBubble.prototype.startTailDrag = function (evt) {


  this.editor.toggleDraggable(false)
  // this.mouse.addEventListener("mouseup", this.stopTailDrag.bind(this));

  // this.tailButton.addEventListener("mousemove", this.updateTailTouch.bind(this));
  var me = this
  //DEsktop;

  this.shiftX = evt.clientX - this.tailButton.getBoundingClientRect().left;
  this.shiftY = evt.clientY - this.tailButton.getBoundingClientRect().top;
  $(document).on('mousemove', function (evt) {
    me.updateTailTouch(evt)
  })
  $(document).on('mouseup', function (evt) {
    me.stopTailDrag()
  })
  //Touch:
  this.tailButton.addEventListener('touchmove', this.updateTailTouch.bind(this))
  this.tailButton.addEventListener('touchend', this.stopTailDrag.bind(this))
  // document.addEventListener('mouseup', this.stopTailDrag.bind(this))
}

CustomSpeechBubble.prototype.stopTailDrag = function () {

  this.removeMouseEvents()
  this.editor.toggleDraggable(true)
}

CustomSpeechBubble.prototype.removeMouseEvents = function () {

  $(document).off('mousemove')
  $(document).off('mouseup')
  //this.tailButton.removeEventListener('mousemove', this.updateTailTouch.bind(this))
  //document.removeEventListener('mouseup', this.stopTailDrag.bind(this))
  this.tailButton.removeEventListener('touchend', this.stopTailDrag.bind(this))
  this.tailButton.removeEventListener('touchmove', this.updateTailTouch.bind(this))

  $(this.tailButton).off()
}

Object.defineProperty(CustomSpeechBubble.prototype, 'mode', {
  get: function () {
    return this._mode
  },
  set: function (_mode) {
    this._mode = _mode
    switch (_mode) {
      case CustomSpeechBubble.modes.EDIT_TAIL:
        this.initEditTailMode()
        break
      case CustomSpeechBubble.modes.EDIT_TEXT:
        this.initEditTextMode()
        break
      case CustomSpeechBubble.modes.EDIT:
        this.initEditMode()
        break
      case CustomSpeechBubble.modes.NORMAL:
        this.initNormalMode()
        break
    }
  }
})

Object.defineProperty(CustomSpeechBubble.prototype, 'x', {
  get: function () {
    return this._x
  },
  set: function (_value) {
    this._x = _value
    this.canvas.style.left = this._x + 'px'
  }
})

Object.defineProperty(CustomSpeechBubble.prototype, 'y', {
  get: function () {
    return this._y
  },
  set: function (_value) {
    this._y = _value
    this.canvas.style.top = this._y + 'px'
  }
})

CustomSpeechBubble.modes = {}
CustomSpeechBubble.modes.EDIT_TAIL = 'editTailMode'
CustomSpeechBubble.modes.EDIT_TEXT = 'editTextMode'
CustomSpeechBubble.modes.EDIT = 'editMode'
CustomSpeechBubble.modes.NORMAL = 'normalMode'
